import List from 'src/storage/list';

class ClinicManagersLocationModel extends List {
  id = 'ClinicManagersLocationModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    sortBy: {
      sortKey: 'date',
      desc: true
    },
    updating: {}
  });

  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'clinic/manager/hospitals',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/manager/hospitals',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/manager/hospitals',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    detail: {
      url: 'clinic/manager/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    edit: {
      url: 'clinic/manager/update',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    'ws:modify_manager': 'onManager',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onManager = (data) => {
    if (Number(data.id) === Number(this.state.manager?.id) && !data.managerRemovedDate) {
      this.setState({ manager: { ...this.state.manager, ...data } });
    }
  };
  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      managerId: this.state.managerId
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  detail(id, cb) {
    this.setState({ manager: null, managerId: id });
    this.refresh();
    this.api('detail', { id }, (err, manager, success) => {
      if (success) {
        this.setState({ manager });
      }
      cb(err, manager, success);
    });
  }
  access = (item, access, active) => {
    this.setState({ updating: { [item.id]: { [access]: active } } });
    this.api(
      'edit',
      {
        id: this.state.manager.id,
        managerAccessHospital: { hospitalId: item.id, [access]: active }
      },
      (err, data, success) => {
        this.setStateSilent({ updating: {} });
        if (success) {
          this.emit('ws:modify_manager', data);
        }
      }
    );
  };
}

const model = new ClinicManagersLocationModel();
export default model;
